import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import React, { CSSProperties } from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, ContentCardProps, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { applyColor }from '~src/style/ColorService';

import { CollectionTooltip } from '../tooltip/CollectionTooltip';
import { CollectionsCardPrivateIndicator } from './CollectionsPrivateIndicator';
import { ICollectionInfo } from './ICollectionInfo';


export class CollectionCard extends ContentCard {


  public render() {
    const { content, addContentFavorite, removeContentFavorite } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        {renderCollectionCardContent(this.props, this.getCardZoomStyle(), this.getCardZoomStyleForThumbnailText())}
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.collectionDetails()}
            />
          </span>
          <span>
            <FavoriteToggle isTabbable={true}
              isFavorite={content.favorite}
              itemName={content.name}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'collection' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'collection' })} />
          </span>
          {this.renderActionsMenu()}
        </div>
        {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>}
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return CollectionTooltip;
  }
}

// This is a separate function so other card components can reuse the collection thumbnail
export function renderCollectionCardContent(contentCardProps: ContentCardProps, zoomStyle: CSSProperties, zoomStyleForThumbnailText: CSSProperties): JSX.Element {
  const shouldDisplayPrivateIndicator = (contentCardProps.content as ICollectionInfo).visibility === 'private';

  return (
    <div>
      <div className={CardViewStyles.CollectionCardInfoLayout} style={zoomStyle}>
        <div className={CardViewStyles.CollectionCardTitleArea}>
          <div className={CardViewStyles.CollectionCardTitleText}>{contentCardProps.content.name}</div>
        </div>
        <div style={{ flexGrow: 1 }} />
        <div
          className={CardViewStyles.CollectionCardTypeLabelArea}
          style={{ ...zoomStyleForThumbnailText, backgroundColor: !(contentCardProps.hovered || contentCardProps.selected) && applyColor(DesignTokens.color.elevation.surface.default.default, TabStyles.Colors.White) }}
        >
          <span className={CardViewStyles.CollectionCardTypeLabel}>{Messages.collection()}</span>
          {shouldDisplayPrivateIndicator && <CollectionsCardPrivateIndicator />}
        </div>
      </div>
      <Thumbnail navigateUrl={getContentUrlForItem(contentCardProps.content, contentCardProps.urls)}
        defaultImageUrl={imgPath('Blue_Gray_Gradient.png')}
        hovered={contentCardProps.hovered}
        selected={contentCardProps.selected}
        imageCoverBackground={true}
        allowDragAndDrop={contentCardProps.allowDragAndDrop}
        aria-label={contentCardProps.content.name}
      />
    </div>);
}
